<template>
    <div v-loading="isLoadingChart">
        <div>
            <div class="d-flex align-items-center align-content-center">
                <div class="flex-fill">
                    <el-select v-model="radioTargetView" 
                               placeholder="Select" size="small" 
                               class="d-block d-md-none" style="width: 12rem;"
                               @change="getCustomerPortraitByMonth">
                        <el-option label="All" value="all" />
                        <el-option label="User Counts" value="userCounts" />
                        <el-option label="Registered Users" value="registeredUsers" />
                        <el-option label="Recharge Amounts" value="rechargeAmounts" />
                        <el-option label="New Payers" value="newPayers" />
                        <el-option label="Payers (1-3M)" value="payers1To3M" />
                        <el-option label="Payers (3-12M)" value="payers3To12M" />
                    </el-select>
                </div>
                <div class="d-flex align-items-center">
                    <select class="form-control form-control-sm mr-2"
                            style="width: 8rem;" v-model="numberOfMonth"
                            @change="getCustomerPortraitByMonth">
                        <option :value="6">Last 6 months</option>
                        <option :value="8">Last 8 months</option>
                        <option :value="10">Last 10 months</option>
                        <option :value="12">Last 12 months</option>
                        <option :value="24">Last 24 months</option>
                    </select>
                    <button class="btn btn-sm btn-primary" @click="getCustomerPortraitByMonth(true)">
                        <i class="fas fa-sync-alt mr-2"></i> Refresh
                    </button>
                </div>
            </div>
        </div>
        <!-- Layout for numberOfMonth !== 24 (same row) -->
        <div v-if="numberOfMonth !== 24" class="row mt-4">
            <div class="col-md-9">
                <div class="card h-100">
                    <div class="card-header">
                        <h5 class="card-title mb-0">Customer Portrait Overview</h5>
                    </div>
                    <div class="card-body">
                        <highcharts :options="customerPoritraitByMonth.options"></highcharts>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card h-100">
                    <div class="card-header">
                        <h6 class="card-title mb-2 text-center">Monthly Revenue Structure</h6>
                    </div>
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <highcharts :options="pieChartOptions" class="w-100"></highcharts>
                        </div>
                    </div>
                    <div class="card-footer bg-white" style="border-radius: 10px; padding: 10px;">
                        <div class="d-flex align-items-center justify-content-between" style="gap: 5px;">
                            <div class="flex-fill">
                                <select class="form-control form-control-sm w-100" 
                                        v-model="selectedPieChartMonth"
                                        @change="updatePieChartByMonth">
                                    <option value="total" style="background: white; color: #333;">Total All Months</option>
                                    <option v-for="month in availableMonths" 
                                            :key="month" 
                                            :value="month"
                                            style="background: white; color: #333;">{{ month }}</option>
                                </select>
                            </div>
                            <div class="flex-fill">
                                <div class="btn-group btn-group-sm w-100" role="group">
                                    <button type="button" 
                                            class="btn btn-sm" 
                                            :class="pieChartDisplayMode === 'amount' ? 'btn-primary' : 'btn-outline-primary'"
                                            @click="changePieChartMode('amount')">
                                        Amount
                                    </button>
                                    <button type="button" 
                                            class="btn btn-sm" 
                                            :class="pieChartDisplayMode === 'count' ? 'btn-primary' : 'btn-outline-primary'"
                                            @click="changePieChartMode('count')">
                                        Count
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Layout for numberOfMonth === 24 (separate rows) -->
        <template v-if="numberOfMonth === 24">
            <!-- Customer Portrait Overview - Full Width -->
            <div class="row mt-4">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title mb-0">Customer Portrait Overview</h5>
                        </div>
                        <div class="card-body">
                            <highcharts :options="customerPortraitFullWidth.options"></highcharts>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Monthly Revenue Structure - Two Charts Side by Side -->
            <div class="row mt-4">
                <div class="col-md-6">
                    <div class="card h-100">
                        <div class="card-header">
                            <h6 class="card-title mb-2 text-center">Monthly Revenue Structure - Amount</h6>
                        </div>
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <highcharts :options="pieChartAmountOptions" class="w-100"></highcharts>
                            </div>
                        </div>
                        <div class="card-footer bg-white" style="border-radius: 10px; padding: 10px;">
                            <div class="d-flex align-items-center justify-content-center">
                                <select class="form-control form-control-sm" 
                                        style="width: 200px;"
                                        v-model="selectedPieChartMonth"
                                        @change="updatePieChartsByMonth">
                                    <option value="total" style="background: white; color: #333;">Total All Months</option>
                                    <option v-for="month in availableMonths" 
                                            :key="month" 
                                            :value="month"
                                            style="background: white; color: #333;">{{ month }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card h-100">
                        <div class="card-header">
                            <h6 class="card-title mb-2 text-center">Monthly Revenue Structure - Count</h6>
                        </div>
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <highcharts :options="pieChartCountOptions" class="w-100"></highcharts>
                            </div>
                        </div>
                        <div class="card-footer bg-white" style="border-radius: 10px; padding: 10px;">
                            <div class="d-flex align-items-center justify-content-center">
                                <select class="form-control form-control-sm" 
                                        style="width: 200px;"
                                        v-model="selectedPieChartMonth"
                                        @change="updatePieChartsByMonth">
                                    <option value="total" style="background: white; color: #333;">Total All Months</option>
                                    <option v-for="month in availableMonths" 
                                            :key="month" 
                                            :value="month"
                                            style="background: white; color: #333;">{{ month }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!-- Prime Analytics Chart -->
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title mb-0">Prime vs Regular Analytics</h5>
                    </div>
                    <div class="card-body">
                        <highcharts :options="primeChartOptions"></highcharts>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
    </div>
</template>
<script>
    import chartDataApi from '@/api/common/chartData';
    import Highcharts from 'highcharts';
    import { 
        areaSplineChart,
        colorSun, colorSat, colorNormal
    } from "@/constant/dashboardChartOptions";
    import { Chart } from 'highcharts-vue';
    export default {
        components: {
            highcharts: Chart
        },
        data() {
            return {
                isLoadingChart: false,
                radioTargetView: 'all',
                numberOfMonth : 6,
                selectedPieChartMonth: '',
                pieChartDisplayMode: 'amount', // 'amount' or 'count'
                availableMonths: [],
                currentData: [],
                customerPoritraitByMonth: {
                    options: Object.assign(JSON.parse(JSON.stringify(areaSplineChart)), {
                        chart: {
                            height: 500,
                            type: 'areaspline'
                        },
                        yAxis: [],
                        tooltip: {
                            shared: true
                        },
                        plotOptions: {
                            areaspline: {
                                dataLabels: {
                                    enabled: true
                                },
                                fillOpacity: 0.5
                            }
                        },
                    }),
                    tableData: []
                },
                customerPortraitFullWidth: {
                    options: Object.assign(JSON.parse(JSON.stringify(areaSplineChart)), {
                        chart: {
                            height: 600,
                            type: 'areaspline'
                        },
                        yAxis: [],
                        tooltip: {
                            shared: true
                        },
                        plotOptions: {
                            areaspline: {
                                dataLabels: {
                                    enabled: true
                                },
                                fillOpacity: 0.5
                            }
                        },
                    }),
                    tableData: []
                },
                pieChartOptions: {
                    chart: {
                        type: 'pie',
                        height: 400
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b><br/>Value: <b>{point.y:,.0f}</b>',
                        formatter: function() {
                            let tooltip = `<b>${this.point.name}</b><br/>`;
                            tooltip += `Percentage: <b>${this.point.percentage.toFixed(1)}%</b><br/>`;
                            
                            if (this.point.series.name.includes('Amount')) {
                                tooltip += `Amount: <b>$${this.point.y.toLocaleString()}</b><br/>`;
                            } else {
                                tooltip += `Count: <b>${this.point.y.toLocaleString()} users</b><br/>`;
                            }
                            
                            if (this.point.custom && this.point.custom.tooltip) {
                                tooltip += `<span style="font-size:9px;color:#666">${this.point.custom.tooltip}</span>`;
                            }
                            
                            // Display sub-items if they exist
                            if (this.point.custom && this.point.custom.subItems && this.point.custom.subItems.length > 0) {
                                tooltip += '<br/><br/><b>Breakdown:</b><br/>';
                                const parentValue = this.point.y;
                                
                                this.point.custom.subItems.forEach(subItem => {
                                    const valueDisplay = this.point.series.name.includes('Amount') 
                                        ? `$${subItem.value.toLocaleString()}` 
                                        : `${subItem.value.toLocaleString()} users`;
                                    
                                    // Calculate percentage of subItem relative to parent
                                    const percentage = parentValue > 0 ? ((subItem.value / parentValue) * 100).toFixed(1) : 0;
                                    
                                    tooltip += `• ${subItem.name}: <b>${valueDisplay}</b> <span style="color:#007bff;">(${percentage}%)</span><br/>`;
                                    if (subItem.desc) {
                                        tooltip += `  <span style="font-size:8px;color:#888">${subItem.desc}</span><br/>`;
                                    }
                                });
                            }
                            
                            return tooltip;
                        }
                    },
                    accessibility: {
                        point: {
                            valueSuffix: '%'
                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                            },
                            showInLegend: false
                        }
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    series: [{
                        name: 'Recharge Amount',
                        colorByPoint: true,
                        data: []
                    }]
                },
                pieChartAmountOptions: {
                    chart: {
                        type: 'pie',
                        height: 400
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b><br/>Value: <b>{point.y:,.0f}</b>',
                        formatter: function() {
                            let tooltip = `<b>${this.point.name}</b><br/>`;
                            tooltip += `Percentage: <b>${this.point.percentage.toFixed(1)}%</b><br/>`;
                            tooltip += `Amount: <b>$${this.point.y.toLocaleString()}</b><br/>`;
                            
                            if (this.point.custom && this.point.custom.tooltip) {
                                tooltip += `<span style="font-size:9px;color:#666">${this.point.custom.tooltip}</span>`;
                            }
                            
                            // Display sub-items if they exist
                            if (this.point.custom && this.point.custom.subItems && this.point.custom.subItems.length > 0) {
                                tooltip += '<br/><br/><b>Breakdown:</b><br/>';
                                const parentValue = this.point.y;
                                
                                this.point.custom.subItems.forEach(subItem => {
                                    const valueDisplay = `$${subItem.value.toLocaleString()}`;
                                    
                                    // Calculate percentage of subItem relative to parent
                                    const percentage = parentValue > 0 ? ((subItem.value / parentValue) * 100).toFixed(1) : 0;
                                    
                                    tooltip += `• ${subItem.name}: <b>${valueDisplay}</b> <span style="color:#007bff;">(${percentage}%)</span><br/>`;
                                    if (subItem.desc) {
                                        tooltip += `  <span style="font-size:8px;color:#888">${subItem.desc}</span><br/>`;
                                    }
                                });
                            }
                            
                            return tooltip;
                        }
                    },
                    accessibility: {
                        point: {
                            valueSuffix: '%'
                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                            },
                            showInLegend: false
                        }
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    series: [{
                        name: 'Recharge Amount',
                        colorByPoint: true,
                        data: []
                    }]
                },
                pieChartCountOptions: {
                    chart: {
                        type: 'pie',
                        height: 400
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b><br/>Value: <b>{point.y:,.0f}</b>',
                        formatter: function() {
                            let tooltip = `<b>${this.point.name}</b><br/>`;
                            tooltip += `Percentage: <b>${this.point.percentage.toFixed(1)}%</b><br/>`;
                            tooltip += `Count: <b>${this.point.y.toLocaleString()} users</b><br/>`;
                            
                            if (this.point.custom && this.point.custom.tooltip) {
                                tooltip += `<span style="font-size:9px;color:#666">${this.point.custom.tooltip}</span>`;
                            }
                            
                            // Display sub-items if they exist
                            if (this.point.custom && this.point.custom.subItems && this.point.custom.subItems.length > 0) {
                                tooltip += '<br/><br/><b>Breakdown:</b><br/>';
                                const parentValue = this.point.y;
                                
                                this.point.custom.subItems.forEach(subItem => {
                                    const valueDisplay = `${subItem.value.toLocaleString()} users`;
                                    
                                    // Calculate percentage of subItem relative to parent
                                    const percentage = parentValue > 0 ? ((subItem.value / parentValue) * 100).toFixed(1) : 0;
                                    
                                    tooltip += `• ${subItem.name}: <b>${valueDisplay}</b> <span style="color:#007bff;">(${percentage}%)</span><br/>`;
                                    if (subItem.desc) {
                                        tooltip += `  <span style="font-size:8px;color:#888">${subItem.desc}</span><br/>`;
                                    }
                                });
                            }
                            
                            return tooltip;
                        }
                    },
                    accessibility: {
                        point: {
                            valueSuffix: '%'
                        }
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                            },
                            showInLegend: false
                        }
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    series: [{
                        name: 'User Count',
                        colorByPoint: true,
                        data: []
                    }]
                },
                primeChartOptions: Object.assign(JSON.parse(JSON.stringify(areaSplineChart)), {
                    chart: {
                        height: 450,
                        type: 'areaspline'
                    },
                    title: {
                        text: null
                    },
                    yAxis: [],
                    tooltip: {
                        shared: true
                    },
                    plotOptions: {
                        areaspline: {
                            dataLabels: {
                                enabled: true
                            },
                            fillOpacity: 0.3
                        },
                        column: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    series: []
                })
            };
        },
        mounted() {
            this.getCustomerPortraitByMonth();
        },
        methods: {
            getCustomerPortraitByMonth(isForceNew = false) {
                this.isLoadingChart = true;
                chartDataApi.getCustomerPortraitByMonth(this.numberOfMonth, isForceNew).then(response => {
                    if (response.data && response.data.result === 0 && response.data.data !== null) {
                        // Update both chart options with data
                        this.customerPoritraitByMonth.tableData = response.data.data;
                        this.customerPortraitFullWidth.tableData = response.data.data;
                        
                        // Setup categories for both charts
                        this.customerPoritraitByMonth.options.xAxis.categories = [];
                        this.customerPoritraitByMonth.options.xAxis.categories = response.data.data.map(x => x.MonthExport);
                        this.customerPortraitFullWidth.options.xAxis.categories = [];
                        this.customerPortraitFullWidth.options.xAxis.categories = response.data.data.map(x => x.MonthExport);

                        // Clear existing data for both charts
                        this.customerPoritraitByMonth.options.yAxis = [];
                        this.customerPoritraitByMonth.options.series = [];
                        this.customerPortraitFullWidth.options.yAxis = [];
                        this.customerPortraitFullWidth.options.series = [];
                        
                        // Setup chart configurations for both charts
                        this.setupChartConfiguration(this.customerPoritraitByMonth.options, response.data.data);
                        this.setupChartConfiguration(this.customerPortraitFullWidth.options, response.data.data);



                        // Store current data and update available months
                        this.currentData = response.data.data;
                        this.availableMonths = response.data.data.map(x => x.MonthExport);
                        
                        // Set default to latest month if not already set
                        if (!this.selectedPieChartMonth || !this.availableMonths.includes(this.selectedPieChartMonth)) {
                            this.selectedPieChartMonth = this.availableMonths[this.availableMonths.length - 1];
                        }
                        
                        // Update pie chart(s) with selected month data
                        if (this.numberOfMonth === 24) {
                            this.updatePieChartsByMonth();
                        } else {
                            this.updatePieChartByMonth();
                        }
                        
                        // Update prime chart
                        this.updatePrimeChart(response.data.data);
                        
                        this.isLoadingChart = false;
                    }
                    else {
                        if (response.data && response.data.message !== null && response.data.message !== '') {
                            console.error(response.data.message || this.$lang.common.error);
                        }
                        this.isLoadingChart = false;
                    }
                }).catch(error => {
                    console.error(error);
                    this.isLoadingChart = false;
                });
            },
            updatePieChart(data) {
                if (!data || data.length === 0) return;
                
                // Use the provided data (could be single month or aggregated data)
                const chartData = data[0];
                
                if (this.pieChartDisplayMode === 'amount') {
                    // Display by amount
                    const totalAmount = chartData.TotalRechargeAmount || 0;
                    const newUsersAmount = chartData.UserRechargeAmount_1To3Months || 0;
                    const returningUsersAmount = chartData.UserRechargeAmount_3To12Months || 0;
                    const loyalUsersAmount = totalAmount - (newUsersAmount + returningUsersAmount);
                    
                    // Get sub-amounts for new users section
                    const oneDepositAmount = chartData.UserRechargeAmount1Deposit || 0;
                    const newUserMonthAmount = chartData.NewUserRechargeAmount || 0;
                    
                    // Update pie chart data for amount
                    this.pieChartOptions.series[0].data = [
                        {
                            name: 'New P.U',
                            y: newUsersAmount,
                            color: '#FF6B6B',
                            custom: {
                                tooltip: 'Khách hàng trả phí - mới đăng ký trong vòng 3 tháng',
                                subItems: [
                                    { name: 'First time P.U', value: oneDepositAmount, desc: 'Khách hàng - trả phí lần đầu' },
                                    { name: 'New Register P.U', value: newUserMonthAmount, desc: 'Khách hàng trả phí - mới đăng ký tháng này' }
                                ]
                            }
                        },
                        {
                            name: 'Returning P.U',
                            y: returningUsersAmount,
                            color: '#4ECDC4',
                            custom: {
                                tooltip: 'Khách hàng trả phí - đã đăng ký trên 3 tháng - 1 năm'
                            }
                        },
                        {
                            name: 'Loyal P.U',
                            y: loyalUsersAmount > 0 ? loyalUsersAmount : 0,
                            color: '#45B7D1',
                            custom: {
                                tooltip: 'Khách hàng trả phí - đã đăng ký trên 1 năm'
                            }
                        }
                    ];

                    // Update series name for amount mode
                    this.pieChartOptions.series[0].name = 'Recharge Amount';
                    
                    // Add subtitle with total amount
                    this.pieChartOptions.subtitle = {
                        text: `Total: $${totalAmount.toLocaleString()}<br/>${chartData.MonthExport || 'Selected Period'}`,
                        align: 'center',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }
                    };
                } else {
                    // Display by user count
                    const totalCount = chartData.TotalRechargeUserCount || 0;
                    const newUsersCount = chartData.RechargeUserCount_1To3Months || 0;
                    const returningUsersCount = chartData.RechargeUserCount_3To12Months || 0;
                    const loyalUsersCount = totalCount - (newUsersCount + returningUsersCount);
                    
                    // Get sub-counts for new users section
                    const oneDepositCount = chartData.CountUser1Deposit || 0;
                    const newUserMonthCount = chartData.NewRechargeUserCount || 0;
                    
                    // Update pie chart data for count
                    this.pieChartOptions.series[0].data = [
                        {
                            name: 'New P.U',
                            y: newUsersCount,
                            color: '#FF6B6B',
                            custom: {
                                tooltip: 'Khách hàng trả phí - mới đăng ký trong vòng 3 tháng',
                                subItems: [
                                    { name: 'First time P.U', value: oneDepositCount, desc: 'Khách hàng - trả phí lần đầu' },
                                    { name: 'New Register P.U', value: newUserMonthCount, desc: 'Khách hàng trả phí - mới đăng ký tháng này' }
                                ]
                            }
                        },
                        {
                            name: 'Returning P.U',
                            y: returningUsersCount,
                            color: '#4ECDC4',
                            custom: {
                                tooltip: 'Khách hàng trả phí - đã đăng ký trên 3 tháng - 1 năm'
                            }
                        },
                        {
                            name: 'Loyal P.U',
                            y: loyalUsersCount > 0 ? loyalUsersCount : 0,
                            color: '#45B7D1',
                            custom: {
                                tooltip: 'Khách hàng trả phí - đã đăng ký trên 1 năm'
                            }
                        }
                    ];

                    // Update series name for count mode
                    this.pieChartOptions.series[0].name = 'User Count';
                    
                    // Add subtitle with total count
                    this.pieChartOptions.subtitle = {
                        text: `Total: ${totalCount.toLocaleString()} users<br/>${chartData.MonthExport || 'Selected Period'}`,
                        align: 'center',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }
                    };
                }
            },
            updatePieChartsByMonth() {
                if (!this.currentData || this.currentData.length === 0) return;
                
                let dataToUse;
                
                if (this.selectedPieChartMonth === 'total') {
                    // Calculate totals for all months
                    dataToUse = {
                        TotalRechargeAmount: this.currentData.reduce((sum, item) => sum + (item.TotalRechargeAmount || 0), 0),
                        TotalRechargeUserCount: this.currentData.reduce((sum, item) => sum + (item.TotalRechargeUserCount || 0), 0),
                        UserRechargeAmount_1To3Months: this.currentData.reduce((sum, item) => sum + (item.UserRechargeAmount_1To3Months || 0), 0),
                        RechargeUserCount_1To3Months: this.currentData.reduce((sum, item) => sum + (item.RechargeUserCount_1To3Months || 0), 0),
                        UserRechargeAmount_3To12Months: this.currentData.reduce((sum, item) => sum + (item.UserRechargeAmount_3To12Months || 0), 0),
                        RechargeUserCount_3To12Months: this.currentData.reduce((sum, item) => sum + (item.RechargeUserCount_3To12Months || 0), 0),
                        UserRechargeAmount1Deposit: this.currentData.reduce((sum, item) => sum + (item.UserRechargeAmount1Deposit || 0), 0),
                        CountUser1Deposit: this.currentData.reduce((sum, item) => sum + (item.CountUser1Deposit || 0), 0),
                        NewUserRechargeAmount: this.currentData.reduce((sum, item) => sum + (item.NewUserRechargeAmount || 0), 0),
                        NewRechargeUserCount: this.currentData.reduce((sum, item) => sum + (item.NewRechargeUserCount || 0), 0),
                        MonthExport: 'All Months'
                    };
                } else {
                    // Find specific month data
                    dataToUse = this.currentData.find(item => item.MonthExport === this.selectedPieChartMonth);
                    if (!dataToUse) return;
                }
                
                // Update Amount Chart
                const totalAmount = dataToUse.TotalRechargeAmount || 0;
                const newUsersAmount = dataToUse.UserRechargeAmount_1To3Months || 0;
                const returningUsersAmount = dataToUse.UserRechargeAmount_3To12Months || 0;
                const loyalUsersAmount = totalAmount - (newUsersAmount + returningUsersAmount);
                
                const oneDepositAmount = dataToUse.UserRechargeAmount1Deposit || 0;
                const newUserMonthAmount = dataToUse.NewUserRechargeAmount || 0;
                
                this.pieChartAmountOptions.series[0].data = [
                    {
                        name: 'New P.U',
                        y: newUsersAmount,
                        color: '#FF6B6B',
                        custom: {
                            tooltip: 'Khách hàng trả phí - mới đăng ký trong vòng 3 tháng',
                            subItems: [
                                { name: 'First time P.U', value: oneDepositAmount, desc: 'Khách hàng - trả phí lần đầu' },
                                { name: 'New Register P.U', value: newUserMonthAmount, desc: 'Khách hàng trả phí - mới đăng ký tháng này' }
                            ]
                        }
                    },
                    {
                        name: 'Returning P.U',
                        y: returningUsersAmount,
                        color: '#4ECDC4',
                        custom: {
                            tooltip: 'Khách hàng trả phí - đã đăng ký trên 3 tháng - 1 năm'
                        }
                    },
                    {
                        name: 'Loyal P.U',
                        y: loyalUsersAmount > 0 ? loyalUsersAmount : 0,
                        color: '#45B7D1',
                        custom: {
                            tooltip: 'Khách hàng trả phí - đã đăng ký trên 1 năm'
                        }
                    }
                ];
                
                this.pieChartAmountOptions.subtitle = {
                    text: `Total: $${totalAmount.toLocaleString()}<br/>${dataToUse.MonthExport || 'Selected Period'}`,
                    align: 'center',
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
                };
                
                // Update Count Chart
                const totalCount = dataToUse.TotalRechargeUserCount || 0;
                const newUsersCount = dataToUse.RechargeUserCount_1To3Months || 0;
                const returningUsersCount = dataToUse.RechargeUserCount_3To12Months || 0;
                const loyalUsersCount = totalCount - (newUsersCount + returningUsersCount);
                
                const oneDepositCount = dataToUse.CountUser1Deposit || 0;
                const newUserMonthCount = dataToUse.NewRechargeUserCount || 0;
                
                this.pieChartCountOptions.series[0].data = [
                    {
                        name: 'New P.U',
                        y: newUsersCount,
                        color: '#FF6B6B',
                        custom: {
                            tooltip: 'Khách hàng trả phí - mới đăng ký trong vòng 3 tháng',
                            subItems: [
                                { name: 'First time P.U', value: oneDepositCount, desc: 'Khách hàng - trả phí lần đầu' },
                                { name: 'New Register P.U', value: newUserMonthCount, desc: 'Khách hàng trả phí - mới đăng ký tháng này' }
                            ]
                        }
                    },
                    {
                        name: 'Returning P.U',
                        y: returningUsersCount,
                        color: '#4ECDC4',
                        custom: {
                            tooltip: 'Khách hàng trả phí - đã đăng ký trên 3 tháng - 1 năm'
                        }
                    },
                    {
                        name: 'Loyal P.U',
                        y: loyalUsersCount > 0 ? loyalUsersCount : 0,
                        color: '#45B7D1',
                        custom: {
                            tooltip: 'Khách hàng trả phí - đã đăng ký trên 1 năm'
                        }
                    }
                ];
                
                this.pieChartCountOptions.subtitle = {
                    text: `Total: ${totalCount.toLocaleString()} users<br/>${dataToUse.MonthExport || 'Selected Period'}`,
                    align: 'center',
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }
                };
            },
            updatePieChartByMonth() {
                if (!this.currentData || this.currentData.length === 0) return;
                
                if (this.selectedPieChartMonth === 'total') {
                    // Calculate totals for all months
                    const totalData = {
                        TotalRechargeAmount: this.currentData.reduce((sum, item) => sum + (item.TotalRechargeAmount || 0), 0),
                        TotalRechargeUserCount: this.currentData.reduce((sum, item) => sum + (item.TotalRechargeUserCount || 0), 0),
                        UserRechargeAmount_1To3Months: this.currentData.reduce((sum, item) => sum + (item.UserRechargeAmount_1To3Months || 0), 0),
                        RechargeUserCount_1To3Months: this.currentData.reduce((sum, item) => sum + (item.RechargeUserCount_1To3Months || 0), 0),
                        UserRechargeAmount_3To12Months: this.currentData.reduce((sum, item) => sum + (item.UserRechargeAmount_3To12Months || 0), 0),
                        RechargeUserCount_3To12Months: this.currentData.reduce((sum, item) => sum + (item.RechargeUserCount_3To12Months || 0), 0),
                        UserRechargeAmount1Deposit: this.currentData.reduce((sum, item) => sum + (item.UserRechargeAmount1Deposit || 0), 0),
                        CountUser1Deposit: this.currentData.reduce((sum, item) => sum + (item.CountUser1Deposit || 0), 0),
                        NewUserRechargeAmount: this.currentData.reduce((sum, item) => sum + (item.NewUserRechargeAmount || 0), 0),
                        NewRechargeUserCount: this.currentData.reduce((sum, item) => sum + (item.NewRechargeUserCount || 0), 0),
                        MonthExport: 'All Months'
                    };
                    this.updatePieChart([totalData]);
                } else {
                    // Find specific month data
                    const monthData = this.currentData.find(item => item.MonthExport === this.selectedPieChartMonth);
                    if (monthData) {
                        this.updatePieChart([monthData]);
                    }
                }
            },
            updatePrimeChart(data) {
                if (!data || data.length === 0) return;
                
                // Set up categories (months)
                this.primeChartOptions.xAxis.categories = data.map(x => x.MonthExport);
                
                // Clear existing data
                this.primeChartOptions.yAxis = [];
                this.primeChartOptions.series = [];
                
                // Add Amount yAxis for decimal values (lines)
                this.primeChartOptions.yAxis.push({ // Primary yAxis
                    title: {
                        text: 'Amount ($)',
                        style: {
                            "font-size": 15,
                        }
                    },
                    labels: {
                        format: '${value}',
                    }
                });

                // Add User Count yAxis for integer values (columns)
                this.primeChartOptions.yAxis.push({ // Secondary yAxis
                    labels: {
                        format: '{value}',
                        style: {
                            color: Highcharts.getOptions().colors[1]
                        }
                    },
                    title: {
                        text: 'Count',
                        style: {
                            color: Highcharts.getOptions().colors[1],
                            "font-size": 15,
                        }
                    },
                    opposite: true
                });

                // User Count Series (Columns - Integer values)
                this.primeChartOptions.series.push({
                    name: "Total P.U",
                    yAxis: 1,
                    type: 'column',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valueSuffix: ' users'
                    },
                    data: data.map(x => ({
                        y: x.TotalRechargeUserCount || 0
                    })),
                    color: '#3498DB'
                });

                this.primeChartOptions.series.push({
                    name: "Prime P.U",
                    yAxis: 1,
                    type: 'column',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valueSuffix: ' users'
                    },
                    data: data.map(x => ({
                        y: x.PrimeRechargeCount || 0
                    })),
                    color: '#E74C3C'
                });

                // Amount Series (Lines - Decimal values)
                this.primeChartOptions.series.push({
                    name: "Total Recharge Amount",
                    yAxis: 0,
                    type: 'spline',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valuePrefix: '$'
                    },
                    data: data.map(x => ({
                        y: x.TotalRechargeAmount || 0
                    })),
                    color: '#2ECC71'
                });

                this.primeChartOptions.series.push({
                    name: "Prime Recharge Amount",
                    yAxis: 0,
                    type: 'spline',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valuePrefix: '$'
                    },
                    data: data.map(x => ({
                        y: x.PrimeRechargeAmount || 0
                    })),
                    color: '#F39C12'
                });

                this.primeChartOptions.series.push({
                    name: "Total Spent",
                    yAxis: 0,
                    type: 'spline',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valuePrefix: '$'
                    },
                    data: data.map(x => ({
                        y: x.Spent || 0
                    })),
                    color: '#9B59B6'
                });

                this.primeChartOptions.series.push({
                    name: "Prime Spent",
                    yAxis: 0,
                    type: 'spline',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valuePrefix: '$'
                    },
                    data: data.map(x => ({
                        y: x.PrimeSpent || 0
                    })),
                    color: '#E67E22'
                });
            },
            setupChartConfiguration(chartOptions, data) {
                // Configure tooltip to be shared to show all series data
                chartOptions.tooltip.shared = true;
                
                // Add Amount yAxis for decimal values (lines)
                chartOptions.yAxis.push({ // Secondary yAxis
                    title: {
                        text: 'Amount ($)',
                        style: {
                            "font-size": 15,
                        }
                    },
                    labels: {
                        format: '${value}',
                    },
                    opposite: true
                });

                // Add User Count yAxis for integer values (columns)
                chartOptions.yAxis.push({ // Primary yAxis
                    labels: {
                        format: '{value} user(s)',
                        style: {
                            color: Highcharts.getOptions().colors[1]
                        }
                    },
                    title: {
                        text: 'Number of users',
                        style: {
                            color: Highcharts.getOptions().colors[1],
                            "font-size": 15,
                        }
                    }
                });

                // User Count Series (Columns - Integer values)
                // Add CountUserRegister before Total Recharge Users
                chartOptions.series.push({
                    name: "New Registered Users",
                    yAxis: 1,
                    type: 'column',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valueSuffix: ' users<br/><span style="font-size:9px;color:#666">Khách hàng mới đăng ký</span>'
                    },
                    data: data.map(x => ({
                        y: x.CountUserRegister || 0
                    }))
                });

                chartOptions.series.push({
                    name: "Total P.U",
                    yAxis: 1,
                    type: 'column',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valueSuffix: ' users<br/><span style="font-size:9px;color:#666">Tổng số khách nạp tiền trong tháng</span>'
                    },
                    data: data.map(x => ({
                        y: x.TotalRechargeUserCount || 0
                    }))
                });

                chartOptions.series.push({
                    name: "New P.U",
                    yAxis: 1,
                    type: 'column',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valueSuffix: ' users<br/><span style="font-size:9px;color:#666">Khách hàng trả phí - mới đăng ký trong vòng 3 tháng</span>'
                    },
                    data: data.map(x => ({
                        y: x.RechargeUserCount_1To3Months || 0
                    }))
                });

                // Move Recharge New Users after Recharge Users (1-3 Months)
                chartOptions.series.push({
                    name: "New Register P.U",
                    yAxis: 1,
                    type: 'column',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valueSuffix: ' users<br/><span style="font-size:9px;color:#666">Khách hàng trả phí - mới đăng ký trong tháng này</span>'
                    },
                    data: data.map(x => ({
                        y: x.NewRechargeUserCount || 0
                    }))
                });

                chartOptions.series.push({
                    name: "Returning P.U",
                    yAxis: 1,
                    type: 'column',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valueSuffix: ' users<br/><span style="font-size:9px;color:#666">Khách hàng trả phí - đã đăng ký trên 3 tháng - 1 năm</span>'
                    },
                    data: data.map(x => ({
                        y: x.RechargeUserCount_3To12Months || 0
                    }))
                });

                // Amount Series (Lines - Decimal values)
                chartOptions.series.push({
                    name: "Total Recharge Amount",
                    yAxis: 0,
                    type: 'spline',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valuePrefix: '$',
                        valueSuffix: '<br/><span style="font-size:9px;color:#666">Tổng tiền khách nạp trong tháng ($)</span>'
                    },
                    data: data.map(x => ({
                        y: x.TotalRechargeAmount || 0
                    }))
                });

                chartOptions.series.push({
                    name: "Total Spent",
                    yAxis: 0,
                    type: 'spline',
                    dataLabels: {
                        enabled: true
                    },
                    tooltip: {
                        valuePrefix: '$',
                        valueSuffix: '<br/><span style="font-size:9px;color:#666">TỔng point khách dùng trong tháng - đã bao gồm bonus (iRp)</span>'
                    },
                    data: data.map(x => ({
                        y: x.Spent || 0
                    }))
                });
            },
            changePieChartMode(mode) {
                this.pieChartDisplayMode = mode;
                this.updatePieChartByMonth();
            }
        }
    }
</script>